// extracted by mini-css-extract-plugin
export default {"root":"ETVIj","item":"RLJH4","itemTitle":"c3YDC","itemInner":"iw9Gr"};